<div class="icon-counter" 
[ngClass]="{
  blue: color === 'blue',
  'icon-only': number === '',
}">
  <i [class]="icon"></i>
  <span>{{number}}</span>
</div>